export default __webpack_public_path__ + "static/s8-4cd038192657630206ba2da82e3c426e.jpg";